import { useEffect } from 'react';
import { useStoreActions, useStoreState } from 'easy-peasy';
import { get, isEmpty } from 'lodash/fp';
import { parseInt } from '../../helpers/utils';
import useLocationQuery from '../useLocationQuery';
import useCurrentUser from '../useCurrentUser';

export default (reservationId = '') => {
  const userSession = useCurrentUser();
  const { pantryPath = '' } = useLocationQuery();
  const {
    data: reservation,
    meta,
    loading,
    programIds,
    hasMininumDetails,
    hasProgramPicklists
  } = useStoreState(get('reservation'));
  const {
    data: fieldsSettings,
    loading: loadingFieldsSettings,
    pantryPath: statePantryPath
  } = useStoreState(get('pantryReservationFieldsSettings'));
  const {
    data: programsPicklists,
    loading: loadingProgramsPicklists
  } = useStoreState(get('programsPicklists'));

  const fetchReservation = useStoreActions(get('reservation.fetch'));
  const fetchFieldsSettings = useStoreActions(
    get('pantryReservationFieldsSettings.fetch')
  );
  const fetchProgramsPicklists = useStoreActions(
    get('programsPicklists.fetch')
  );

  // Load Reservation
  useEffect(() => {
    if (!userSession || !pantryPath || !reservationId || loading) return;

    const id = parseInt(reservationId);
    if (id && id !== get('id', reservation)) {
      fetchReservation({ pantryPath, id });
    }
  }, [pantryPath, reservationId, reservation, loading]);

  // Load ReservationFieldSettings
  useEffect(() => {
    if (!pantryPath || loadingFieldsSettings) return;

    if (!fieldsSettings || pantryPath !== statePantryPath) {
      fetchFieldsSettings(pantryPath);
    }
  }, [loadingFieldsSettings, pantryPath, statePantryPath, fieldsSettings]);

  // Load ProgramsPicklists
  useEffect(() => {
    if (!pantryPath || isEmpty(programIds)) return;

    if (!programsPicklists && !loadingProgramsPicklists) {
      fetchProgramsPicklists({ pantryPath, programIds });
    }
  }, [pantryPath, loadingProgramsPicklists, programsPicklists, programIds]);

  return {
    loading,
    meta,
    reservation,
    programIds,
    hasMininumDetails,
    hasProgramPicklists
  };
};
